import { Navigate, Outlet } from "react-router-dom";

const ProductedRouter = (props)=>{
    return props.isLoggedIn || sessionStorage.getItem("login") ? <Outlet /> : <Navigate to={"/"} /> ;
};

export default ProductedRouter;